import Iptu from "@/domain/automacaoFiscal/iptu/Iptu";
import Table from "./Table";
export default class TableIptu extends Table {

    getHeaders() {
        var headers;
        headers = [

            { text: "Ações", value: "acoes", show: true, pesq: false, enable: false },
            {text:"_id",value:"_id",show:false,pesq:false,enable:true},
            {text:"Inscricao",value:"inscricao",show:true,pesq:true,enable:true},
            {text:"Obra",value:"obra",show:true,pesq:true,enable:true},
            {text:"Ano",value:"anoIPTU",show:true,pesq:true,enable:true},
            {text:"Parcela",value:"parcela",show:true,pesq:true,enable:true},
            {text:"Bairro",value:"bairro",show:true,pesq:true,enable:true},
            {text:"Data Importação",value:"createdAt",show:true,pesq:true,enable:true},
            {text:"Cidade",value:"cidade",show:true,pesq:true,enable:true},
            {text:"Status OCR",value:"statusOcr",show:true,pesq:true,enable:true},
            {text:"Status Integração",value:"statusIntegracao",show:true,pesq:true,enable:true},
            {text:"Número do Documento",value:"numDoc",show:true,pesq:true,enable:true},
            {text:"Logradouro",value:"logradouro",show:true,pesq:true,enable:true},
            {text:"Vencimento",value:"vencimento",show:true,pesq:true,enable:true},
            {text:"Código de barras",value:"codBarras",show:true,pesq:true,enable:true},
            {text:"Valor Cobrado",value:"valorCobrado",show:true,pesq:true,enable:true},
            {text:"Acréscimo",value:"acrescimos",show:true,pesq:true,enable:true},
            {text:"Dedução",value:"deducoes",show:true,pesq:true,enable:true},
            {text:"Desconto",value:"desconto",show:true,pesq:true,enable:true},
            {text:"Multa",value:"multa",show:true,pesq:true,enable:true},
            {text:"Valor",value:"valor",show:true,pesq:true,enable:true},
            {text:"Log de Integração",value:"log_integracao",show:false,pesq:false,enable:false},
            {text:"pathIPTU",value:"pathIPTU",show:false,pesq:false,enable:false}
        ]
    return headers
    }

    setNota(arrayNotas, notas) {
        let newArray = arrayNotas;
        this.loading = false;
        for (var i = 0; i < notas.length; i++) {
            newArray.push(
                new Iptu(
                    notas[i]._id,
                    notas[i].inscricao,
                    notas[i].obra,
                    notas[i].anoIPTU,
                    notas[i].parcela,
                    notas[i].bairro,
                    notas[i].createdAt,
                    notas[i].cidade,
                    notas[i].statusOcr,
                    notas[i].statusIntegracao,
                    notas[i].numDoc,
                    notas[i].logradouro,
                    notas[i].vencimento,
                    notas[i].codBarras,
                    notas[i].valorCobrado,
                    notas[i].acrescimos,
                    notas[i].deducoes,
                    notas[i].desconto,
                    notas[i].multa,
                    notas[i].valor,
                    notas[i].log_integracao,
                    notas[i].pathIPTU
                )
            );
            
        }

        
        this.pagination.sortBy = 'inscricaoImovel';
        this.pagination.descending = false;
        if(arrayNotas.length > 0) {
            arrayNotas = [ ...arrayNotas, ...newArray ];
            return arrayNotas;
        }else {
            return newArray;
        }
    }
}





// WEBPACK FOOTER //
// ./src/domain/dataTable/TableIptu.js